import { Repository } from "../../adapters/repository";
import { normalizeSettings } from "../../entities/settingsParser";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getPlanzoneSettings(planzone)
        .then(normalizeSettings)
        .then((settings) => ({ settings, planzone }))
        .catch(() => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
